// Enhanced centralized API configuration
// All environment variable access should go through this module

/**
 * Validates environment configuration on module load
 * Logs warning if critical env vars missing (not fatal - has fallback)
 */
const validateConfig = () => {
  if (!process.env.REACT_APP_BACKEND_URL) {
    console.warn('⚠️ REACT_APP_BACKEND_URL not set, using fallback to window.location.origin');
    console.warn('   This is normal for local development but should be set in production');
  }
};

validateConfig();

const config = {
  // Backend URL (used for non-API endpoints like health checks)
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL || (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000'),
  
  // API base URL (primary - use this for axios.defaults.baseURL)
  API_BASE: `${process.env.REACT_APP_BACKEND_URL || (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000')}/api`,
  
  // Timeout configuration
  DEFAULT_TIMEOUT: 10000,
  
  // Environment detection
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
};

/**
 * USAGE GUIDELINES:
 * 
 * 1. For API endpoints - Use relative paths with axios (axios.defaults.baseURL is set in App.js)
 *    ✅ axios.get('/parks')
 *    ❌ axios.get(`${API_BASE}/parks`)
 * 
 * 2. For non-API endpoints (health checks, webhooks) - Use BACKEND_URL
 *    ✅ axios.get(`${BACKEND_URL}/health`)
 * 
 * 3. Never access process.env directly in components
 *    ❌ process.env.REACT_APP_BACKEND_URL
 *    ✅ import { BACKEND_URL } from '../config/api'
 */

export default config;
export const { BACKEND_URL, API_BASE, DEFAULT_TIMEOUT, IS_PRODUCTION, IS_DEVELOPMENT } = config;
